// @ts-nocheck

import React, { useCallback } from 'react';
import styled from 'styled-components';

import useRouter from '../../hooks/useRouter';
import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';
import RoundedButton from '../RoundedButton';

const Wrapper = styled.div``;

const StyledCashinButton = styled(RoundedButton)`
  box-sizing: border-box;
  width: 100%;
  height: 2.27em;
`;

const HistoryItemCashoutButtonEnhance = ({ cashoutEnhance, id, isDisabled }) => {
  const { history } = useRouter();

  const onClick = useCallback(() => {
    history.push(RoutesRedirectionFactory.getHomeRouteConfig());
    cashoutEnhance(id);
  }, [cashoutEnhance, id, history]);

  return (
    <Wrapper>
      <StyledCashinButton
        disabled={isDisabled}
        onClick={onClick}
        label={__('Enhance')}
        color={theme.History.betslip.actions.buttonColor}
        backgroundColor={theme.History.betslip.actions.completeButtonBackgroundColor}
      />
    </Wrapper>
  );
};

export default HistoryItemCashoutButtonEnhance;
